import { Checkbox, CircularProgress, Icon, IconButton, Input, Paper, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from "@material-ui/core";
import ArtApi from "../../api/ArtApi";
import { useEffect, useState } from 'react';
import JSZip from 'jszip';

export const Export = () => {
    const [loading, setLoading] = useState<Boolean>(false);
    const [taggedTasks, setTaggedTasks] = useState<any[]>([]);
    const [tasksSelected, setTasksSelected] = useState<any[]>([]);
    const [filteredTasks, setFilteredTasks] = useState<any[]>([]);
    const [progress, setProgress] = useState<number>(-1);
    const [includeData, setIncludeData] = useState<Boolean>(false);

    // call loadTaggedTasks on page load
    useEffect(() => {
        loadTaggedTasks();
    }, []);

    useEffect(() => {
        setFilteredTasks(taggedTasks);
    }, [taggedTasks]);

    const exportEvents = async () => {
        setLoading(true);
        console.log(tasksSelected);

        let allTasks = tasksSelected.map((task) => {
            return async() => {
                const res = await ArtApi.getSingleTask(task, includeData.valueOf());
                res.data.metaData.taskID = task;
                return res.data;
            }
        });

        let tasks = [];
        setProgress(allTasks.length);
        while (allTasks.length) {
            const newTasks = await Promise.all(allTasks.splice(0, 5).map(f => f()));
            tasks.push(...newTasks);
            setProgress(allTasks.length);
        }
        setProgress(-1);
        
        // turn all the tasks into json files and then add them to a zip file
        const zip = new JSZip();
        tasks.forEach((task, index) => {
            const json = JSON.stringify(task);
            zip.file(`${task.metaData.taskID}.json`, json);
        });

        // Download the zip file
        const content = await zip.generateAsync({ type: 'blob' })
        const url = window.URL.createObjectURL(content);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'testCases.zip'); //or any other extension
        document.body.appendChild(link);
        link.click();
        setLoading(false);

    };

    const updateFilter = (filter: string) => {
        filter = filter || '';
        const newFilteredTasks = taggedTasks.filter(task => {
            return task.id.toLowerCase().includes(filter.toLowerCase()) ||
                task.coreID.toLowerCase().includes(filter.toLowerCase()) ||
                task.taskType.toLowerCase().includes(filter.toLowerCase()) ||
                task.startDate.toLowerCase().includes(filter.toLowerCase()) ||
                task.endDate.toLowerCase().includes(filter.toLowerCase()) ||
                task.tags?.join(',').toLowerCase().includes(filter.toLowerCase()) ||
                filter.length === 0;
        });
        setFilteredTasks(newFilteredTasks);
    };

    const loadTaggedTasks = async () => {
        console.log('Loading tagged tasks...');
        setLoading(true);
        const tasks = await ArtApi.getTasksSlim();
        setTaggedTasks(tasks.data.tasks);
        updateFilter('');
        setLoading(false);
    }

    const selectAll = (checked: boolean) => {
        if (checked) {
            setTasksSelected(filteredTasks.map(task => task.id));
        } else {
            setTasksSelected([]);
        }
    }

    const deleteSelected = async () => {
        setLoading(true);
        await ArtApi.deleteTasks(tasksSelected);
        setLoading(false);
    }

    return (
        <Paper className="paper">
            <Input onChange={(e) => updateFilter(e.target.value)} placeholder="" />

            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Task ID</TableCell>
                        <TableCell>coreID</TableCell>
                        <TableCell>Consumer Type</TableCell>
                        <TableCell>Location Type</TableCell>
                        <TableCell>Start</TableCell>
                        <TableCell>End</TableCell>
                        <TableCell>Tags</TableCell>
                        <TableCell>Select?</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    { filteredTasks.map(task => (
                        <TableRow key={task.id}>
                            <TableCell>{<a href={`/${task.taskType.toLowerCase()}/${task.id}`}>{task.id}</a>}</TableCell>
                            <TableCell>{task.coreID}</TableCell>
                            <TableCell>{task.taskType}</TableCell>
                            <TableCell>{task.locationType}</TableCell>
                            <TableCell>{task.startDate}</TableCell>
                            <TableCell>{task.endDate}</TableCell>
                            <TableCell>{task.tags.join(', ')}</TableCell>
                            <TableCell>
                                <Checkbox
                                checked={tasksSelected.includes(task.id)}
                                onChange={() => {
                                    if (tasksSelected.includes(task.id)) {
                                        setTasksSelected(tasksSelected.filter(t => t !== task.id));
                                    } else {
                                        setTasksSelected([...tasksSelected, task.id]);
                                    }
                                }}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            {loading && <CircularProgress />}
            <div id="export-options">
                <Tooltip title="Export all events with tags to a zip file">
                    <IconButton onClick={exportEvents}>
                        <Icon>file_download</Icon>
                    </IconButton>
                </Tooltip>
                Include timeseries data?
                <Checkbox
                    id="include-data"
                    checked={includeData.valueOf()}
                    onChange={(e) => setIncludeData(e.target.checked) }
                />
                <div style={{ float: 'right'}}>
                    <Tooltip title="Delete selected events.">
                        <IconButton onClick={deleteSelected}>
                            <Icon>delete</Icon>
                        </IconButton>
                    </Tooltip>
                    Select all?
                    <Checkbox
                        id="select-all"
                        onChange={(e) => selectAll(e.target.checked) }
                    />
                </div>
            </div>
            {loading ? "Loading... remaining items: " + progress:null}
        </Paper>
    )
};
